import { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { ApisService } from '../app/core/apis.service';
import { DownloadInfo } from './download-info';
import { useSelector } from 'react-redux';
import LoginOtp from './login-screen';
import { FaCheckCircle } from 'react-icons/fa';
import { GoDotFill } from "react-icons/go";
import { TransactionDetailsUI } from '../components/transaction-details-ui';
import { formatDateTimeInIST } from '../components/indiaDateFormate';


export const Transaction = () => {
  const navigate = useNavigate();
  const [transactionData, setTransactionData] = useState<any>([]);
  const [transactionPackingData, setTransactionPackingData] = useState<any>();
  const [transactionDeliveryData, setTransactionDeliveryData] = useState<any>();
  const [transactionStockReconciliationData, setTransactionStockReconciliationData] = useState<any>();
  const [transactionPaymentReconciliationData, setTransactionPaymentReconciliationData] = useState<any>();
  const [showAppDownload, setShowAppDownload] = useState(false);
  const userData = useSelector((state: any) => state.UserDataReducer);
  const [otpReference, setOtpReference] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState<boolean>(false);
  const [buName, setBuName] = useState<string>();
  const [isBuyer, setIsBuyer] = useState<boolean>(false);
  const [skippedData, setSkippedData] = useState<boolean>(false);
  const [transactionDetails, setTransactionDetails] = useState<any>();


  useEffect(() => {
    if (transactionData[0]) {
      updatePackingData();
      updateDeliveryTracking();
      updateStockReconciliation();
      updatePaymentReconciliation();
    }
  }, [transactionData]);
  const routerParams = useParams();

  type TransactionStatus = {
    [x: string]: any;
    Status: string,

  };

  useEffect(() => {
    loadTransaction();
  }, []);

  async function loadTransaction(): Promise<void> {
    setLoading(true);
    try {
      const res = await ApisService.getTransactionData('getById_v2', routerParams.id || '');
      setLoading(false);
      const data: any = res.data.data;
      const transactionData = JSON.parse(dataDecrypt(data));
      const txnData = [...transactionData];
      setTransactionData(txnData);
      setTransactionDetails([{
        header: 'Seller',
        value: txnData[0]?.seller?.name
      },
      {
        header: 'Txn Date',
        value: formatDateTimeInIST(txnData[0]?.created_date)
      },
      {
        header: 'Txn Id',
        value: txnData[0]?._id
      },
      ])
      const resData = txnData;
      if (resData.length > 0 && resData[0]?.is_offline) {
        if (resData[0]?.discussion?.buyer_accepted && resData[0]?.discussion?.seller_accepted) {
          setShowConfirmationMessage(true);
        }
      }
      if (resData[0]?.sender?.id === resData[0]?.buyer?.id) {
        setBuName(resData[0].buyer.name);
        setIsBuyer(true);
      } else if (resData[0]?.sender?.id === resData[0]?.seller?.id) {
        setBuName(resData[0].seller.name);
        setIsBuyer(false);
      }

      if (resData[0]?.order_type === "offline_direct_sell" || resData[0]?.order_type === "offline_direct_buy") {
        setSkippedData(true);
      }
      const preparedReference = dataEncrypt(JSON.stringify({ id: transactionData[0]._id, type: 'bu_order_form' }));
      setOtpReference(preparedReference);

    } catch (error) {
      setLoading(false);
    }
  }

  const PACKING_COMPLETED: string = "Packing completed";
  const READY_FOR_DELIVERY: string = "Ready for delivery";
  const STOCK_NOT_RESOLVED: string = "Stock not resolved";
  const STOCK_RESOLVED: string = "Stock resolved";
  const PAYMENT_NOT_RESOLVED: string = "Payment not resolved";
  const PAYMENT_RESOLVED: string = "Payment resolved";
  const CTR1: string = "CTR1";
  const CTR3: string = "CTR3";
  const CANCELLED: string = "cancelled";

  interface TransactionItem {
    name: string;
    color: string;
    [x: string]: any;
  }

  const updatePackingData = () => {
    //Packing & Inspections
    if (transactionData[0].invoice_details?.length > 0) {
      let isPendingDetailsUpdated = false;
      let packingCompletedInvoices = 0;
      let packingPendingInvoices = 0;
      let packingCancelledInvoices = 0;

      for (let i = 0; i < transactionData[0].invoice_details.length; i++) {
        if (transactionData[0].invoice_details[i].status === CANCELLED) {
          packingCancelledInvoices = packingCancelledInvoices + 1;
          packingCompletedInvoices = packingCompletedInvoices + 1;
        }
        else if (transactionData[0].invoice_details[i].package_details != null) {

          isPendingDetailsUpdated = true;
          packingCompletedInvoices = packingCompletedInvoices + 1;
        }
        else {
          packingPendingInvoices = packingPendingInvoices + 1;
        }
      }
      if (isPendingDetailsUpdated) {

        const packingobj1 = {
          status: PACKING_COMPLETED,
          packingCompletedInvoices: packingCompletedInvoices === 0 ? "0" : packingCompletedInvoices,
          packingPendingInvoices: packingPendingInvoices === 0 ? "0" : packingPendingInvoices,
          packingCancelledInvoices: packingCancelledInvoices === 0 ? "0" : packingCancelledInvoices
        }
        setTransactionPackingData(packingobj1);
      } else {
        const packingobj2 = {
          status: "Packing Not Completed",
          packingCompletedInvoices: packingCompletedInvoices,
          packingPendingInvoices: packingPendingInvoices,
          packingCancelledInvoices: packingCancelledInvoices
        };
        setTransactionPackingData(packingobj2);
      }
    }
  }

  const updateDeliveryTracking = () => {
    if (transactionData[0].invoice_details?.length > 0) {
      let deliveryCompletedInvoices = 0;
      let deliveryPendingInvoices = 0;
      let isDeliveryDetailsUpdated = false;
      let deliveryCancelledInvoices = 0;

      if ('ctr' in transactionData[0] && transactionData[0].ctr != null && transactionData[0].ctr.type === CTR1) {
        const indexIndirectData = transactionData[0].invoice_details[0];
        if (indexIndirectData.status === CANCELLED) {
          deliveryCancelledInvoices = deliveryCancelledInvoices + 1;
          deliveryCompletedInvoices = deliveryCompletedInvoices + 1;
        }
        else {
          if ('invoice_type' in indexIndirectData && indexIndirectData.invoice_type === CTR3 && indexIndirectData.ctrTransactionDetails != null) {
            if (indexIndirectData.stock_received_status === 'received') {
              isDeliveryDetailsUpdated = true;
              deliveryCompletedInvoices = deliveryCompletedInvoices + 1;
            } else {
              isDeliveryDetailsUpdated = true;
              deliveryPendingInvoices = deliveryPendingInvoices + 1;
            }
          }
        }
      }
      if (isDeliveryDetailsUpdated) {
        const DeliveryObj1 = {
          status: "Delivery Details updated",
          deliveryCompletedInvoices: deliveryCompletedInvoices,
          deliveryPendingInvoices: deliveryPendingInvoices,
          deliveryCancelledInvoices: deliveryCancelledInvoices
        }
        setTransactionDeliveryData(DeliveryObj1);
      }
      for (let i = 0; i < transactionData[0].invoice_details.length; i++) {
        const indexInvoiceDeliveryData = transactionData[0].invoice_details[i];
        if (indexInvoiceDeliveryData.package_details != null) {
          if ('invoice_type' in indexInvoiceDeliveryData && indexInvoiceDeliveryData.invoice_type === CTR3) {
            if (indexInvoiceDeliveryData.stock_received_status === 'received') {
              isDeliveryDetailsUpdated = true;
              deliveryCompletedInvoices = deliveryCompletedInvoices + 1;
            }
            else if ('ctrTransactionDetails' in indexInvoiceDeliveryData && indexInvoiceDeliveryData.ctrTransactionDetails != null) {
              isDeliveryDetailsUpdated = true;
              deliveryPendingInvoices = deliveryPendingInvoices + 1;
            }
            else {
              deliveryPendingInvoices = deliveryPendingInvoices + 1;
            }
          }
          else {
            if (indexInvoiceDeliveryData.order_track != null) {
              if (indexInvoiceDeliveryData.status === CANCELLED) {
                isDeliveryDetailsUpdated = true;
                deliveryCancelledInvoices = deliveryCancelledInvoices + 1;
                deliveryCompletedInvoices = deliveryCompletedInvoices + 1;
              }
              else if (indexInvoiceDeliveryData.stock_received_status === "received") {
                isDeliveryDetailsUpdated = true;
                deliveryCompletedInvoices = deliveryCompletedInvoices + 1;
              }
              else {
                isDeliveryDetailsUpdated = true;
                deliveryPendingInvoices = deliveryPendingInvoices + 1;
              }
            }
            else {
              deliveryPendingInvoices = deliveryPendingInvoices + 1;
            }
          }
        }
      }
      if (isDeliveryDetailsUpdated) {
        const DeliveryObj1 = {
          status: "Delivery Details updated",
          deliveryCompletedInvoices: deliveryCompletedInvoices === 0 ? "0" : deliveryCompletedInvoices,
          deliveryPendingInvoices: deliveryPendingInvoices === 0 ? "0" : deliveryPendingInvoices,
          deliveryCancelledInvoices: deliveryCancelledInvoices === 0 ? "0" : deliveryCancelledInvoices,
        }
        setTransactionDeliveryData(DeliveryObj1);
      }
      else {
        const DeliveryObj2 = {
          status: "Delivery Details not updated",
          deliveryCompletedInvoices: deliveryCompletedInvoices === 0 ? "0" : deliveryCompletedInvoices,
          deliveryPendingInvoices: deliveryPendingInvoices === 0 ? "0" : deliveryPendingInvoices,
          deliveryCancelledInvoices: deliveryCancelledInvoices === 0 ? "0" : deliveryCancelledInvoices,
        }
        setTransactionDeliveryData(DeliveryObj2);
      }
    }
  }

  const updateStockReconciliation = () => {
    //Stock Reconciliation
    if (transactionData[0].invoice_details?.length > 0) {
      let stockResolvedInvoices = 0;
      let stockNotResolvedInvoices = 0;
      let stockcancelledInvoices = 0;
      let stockPendingInvoice = 0;
      let isStockResoved = false;
      let totalCompletedStock = 0;
      for (let i = 0; i < transactionData[0].invoice_details.length; i++) {
        const indexInvoiceData = transactionData[0].invoice_details[i];
        if (transactionData[0].status !== READY_FOR_DELIVERY && indexInvoiceData.stock_reconciliation != null) {
          const indexData = indexInvoiceData.stock_reconciliation;
          if (indexInvoiceData.status === CANCELLED) {
            stockcancelledInvoices = stockcancelledInvoices + 1;
            totalCompletedStock = totalCompletedStock + 1;
          }
          else if (indexData.status === "resolved") {
            stockResolvedInvoices = stockResolvedInvoices + 1;
            totalCompletedStock = totalCompletedStock + 1;
            isStockResoved = true;
          }
          else if (indexData.status === STOCK_NOT_RESOLVED ||
            indexData.status === "not resolved") {
            stockNotResolvedInvoices = stockNotResolvedInvoices + 1;
            totalCompletedStock = totalCompletedStock + 1;
          }
          else if (indexInvoiceData.stock_received_status === 'received') {
            totalCompletedStock = totalCompletedStock + 1;
            isStockResoved = true;
          }
          else if (indexData.status === "pending") {
            stockPendingInvoice = stockPendingInvoice + 1;
          }
        }


        if (isStockResoved) {
          const StockObj1 = {
            status: STOCK_RESOLVED,
            stockResolvedInvoices: stockResolvedInvoices === 0 ? "0" : stockResolvedInvoices,
            stockNotResolvedInvoices: stockNotResolvedInvoices === 0 ? "0" : stockNotResolvedInvoices,
            stockcancelledInvoices: stockcancelledInvoices === 0 ? "0" : stockcancelledInvoices,
            stockPendingInvoice: stockPendingInvoice === 0 ? "0" : stockPendingInvoice,
            totalCompletedStock: totalCompletedStock === 0 ? "0" : totalCompletedStock
          }
          setTransactionStockReconciliationData(StockObj1);

        }
        else {
          const StockObj2 = {
            status: STOCK_NOT_RESOLVED,
            stockResolvedInvoices: stockResolvedInvoices === 0 ? "0" : stockResolvedInvoices,
            stockNotResolvedInvoices: stockNotResolvedInvoices === 0 ? "0" : stockNotResolvedInvoices,
            stockcancelledInvoices: stockcancelledInvoices === 0 ? "0" : stockcancelledInvoices,
            stockPendingInvoice: stockPendingInvoice === 0 ? "0" : stockPendingInvoice,
            totalCompletedStock: totalCompletedStock === 0 ? "0" : totalCompletedStock
          }
          setTransactionStockReconciliationData(StockObj2);
        }
      }
    }
  }

  const updatePaymentReconciliation = () => {

    //Payment Reconciliation         
    if (transactionData[0].invoice_details?.length > 0) {
      let paymentResolved = 0;
      let paymentNotResolved = 0;
      let isPaymentResolved = false;
      let paymentPending = 0;
      let totalCompletedPayment = 0;
      for (let i = 0; i < transactionData[0].invoice_details.length; i++) {
        let isStockResolved = false;
        const indexStockData = transactionData[0].invoice_details[i].stock_reconciliation;
        const indexPaymentData = transactionData[0].invoice_details[i].payment_reconciliation;
        if (indexStockData != null && indexStockData.status === "resolved") {
          isStockResolved = true;
        }
        if (isStockResolved) {
          if (indexPaymentData != null) {
            if (indexPaymentData.status === "resolved") {
              paymentResolved = paymentResolved + 1;
              totalCompletedPayment = totalCompletedPayment + 1;
              isPaymentResolved = true
            }
            else if (indexPaymentData.status === "not resolved") {
              paymentNotResolved = paymentNotResolved + 1;
              totalCompletedPayment = totalCompletedPayment + 1;
            }
            else if (indexPaymentData.status === 'pending') {
              paymentPending = paymentPending + 1;
            }
          }
        }
      }

      if (isPaymentResolved) {
        const paymentobj1 = {
          status: PAYMENT_RESOLVED,

          paymentResolved: paymentResolved === 0 ? "0" : paymentResolved,
          totalCompletedPayment: totalCompletedPayment === 0 ? "0" : totalCompletedPayment,
          paymentPending: paymentPending === 0 ? "0" : paymentPending,
          paymentNotResolved: paymentNotResolved === 0 ? "0" : paymentNotResolved
        }
        setTransactionPaymentReconciliationData(paymentobj1);
      }
      else {
        const paymentobj2 = {
          status: PAYMENT_NOT_RESOLVED,
          paymentResolved: paymentResolved === 0 ? "0" : paymentResolved,
          totalCompletedPayment: totalCompletedPayment === 0 ? "0" : totalCompletedPayment,
          paymentPending: paymentPending === 0 ? "0" : paymentPending,
          paymentNotResolved: paymentNotResolved === 0 ? "0" : paymentNotResolved
        }
        setTransactionPaymentReconciliationData(paymentobj2);
      }
    }
  }

  const openDownloadPopup = () => {
    setShowAppDownload(true);
  }

  const getPurchaseOrderStatus = (transaction: any) => {
    if (transaction?.quotation) {
      return (
        <div className='d-flex justify-content-between align-items f'>
          <div>
            <div className='primary-color'><b>Purchase Order / Quotations </b></div>
            <div className='fs-14'>Status : Quotation {transaction?.quotation?.status === "ignored" ? 'Rejected' : transaction?.quotation?.status === "pending"?"Sent": transaction?.quotation?.status}</div>
            {((transactionData[0]?.invoice_details?.length > 0)) ? "" : <div className='orange-color'>{!isBuyer && <span className='fs-14'>waiting for invoice generation</span>}</div>}
          </div>
          {(transactionData[0]?.invoice_details?.length > 0) ? <div className='text-success'><FaCheckCircle /></div> : <div className="dot-wrapper"><GoDotFill className='slow orange-color' /></div>}
        </div>
      )
    }
    else {
      return (
        <div className='d-flex justify-content-between align-items'>
          <div>
            <div className='primary-color'><b>Purchase Order {!isBuyer ? "/ Quotations" : ""} </b></div>
            {(transactionData[0]?.discussion?.po_accepted && !transactionData[0]?.show_quotation_acceptance) && <div className='fs-14'>Status: {transactionData[0]?.discussion?.po_accepted ? 'PO Completed' : ''}</div>}
            {transactionData[0]?.show_quotation_acceptance && <div className='fs-14 orange-color'>waiting for acceptance</div>}
            {(transactionData[0]?.discussion?.po_accepted && (!transactionData[0]?.show_quotation_acceptance && transactionData[0]?.invoice_details?.length > 0)) ? "" : <div className='orange-color fs-14'>{!isBuyer && <span>waiting for invoice generation</span>}</div>}
          </div>
          {((transactionData[0]?.discussion?.po_accepted || isBuyer) && (!transactionData[0]?.show_quotation_acceptance && transactionData[0]?.invoice_details?.length > 0)) ? <div className='text-success'><FaCheckCircle /></div> : <div className="dot-wrapper"><GoDotFill className='slow orange-color' /></div>}
        </div>
      )
    }
  }

  return (
    <div>
      {(!userData || !userData?.otp) && <LoginOtp reference={otpReference} />}
      {userData?.otp && <>
        <DownloadInfo show={showAppDownload} close={setShowAppDownload}></DownloadInfo>
        <div className='d-flex justify-content-center  p-3 position-relative' style={{ backgroundColor: "#274472", color: "white" }}>
          <h4>Order Tracking</h4>
          <img className='position-absolute end-0 top-0' src={LOGO} alt="" height={60} />
        </div>
        <br />
        <div className='text-center fs-16 mb-1 text-success'>** Purchase Order Between You and {buName} **</div>
        {loading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
          <div className="spinner-border text-secondary" role="status"></div>
        </div> :
          <div>
            {transactionData[0] && <div className='container-fluid'>
              <div style={{ backgroundColor: "white", borderRadius: "3px" }}>
                <TransactionDetailsUI data={transactionDetails} />
              </div>
              <br />
              <div>
                {!skippedData && <Card className='mb-3 rounded-4 cursor-pointer' onClick={() => navigate(`/customer-chat/${transactionData[0]?._id}/order-discussion/${routerParams.id}`)}>
                  <Card.Body >
                    <div className='d-flex justify-content-between align-items'>
                      <div>
                        <div>
                          <b className='primary-color'>Order Discussions</b>
                        </div>
                        <div className='fs-14'>status : Discussion completed</div>
                      </div>
                      {transactionData[0]?.discussion?.messages?.length > 0 && <div className='text-success'><FaCheckCircle /></div>}
                    </div>
                  </Card.Body>
                </Card>}
                {!skippedData && <Card className={`mb-3 rounded-4 ${showConfirmationMessage ? 'box-shadow cursor-pointer' : 'opacity-05'}`} onClick={() => {
                  if (showConfirmationMessage) {
                    navigate(`/confirmation-message/${routerParams.id}`);
                  }
                }}>
                  <Card.Body >
                    <div className='d-flex justify-content-between align-items'>
                      <div>
                        <div className={showConfirmationMessage ? 'primary-color' : 'text-dark'}><b>Confirmation Message</b></div>
                        {showConfirmationMessage ? <div className='fs-14'>status : Discussion Accepted</div> : <div>Option not used for this order</div>}
                      </div>
                      {showConfirmationMessage && <div className='text-success'><FaCheckCircle /></div>}
                    </div>
                  </Card.Body>
                </Card>}
                <Card className='mb-3 box-shadow rounded-4' >
                  <Link to={`/purchase-order/${routerParams.id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                    <Card.Body >
                      <div>{getPurchaseOrderStatus(transactionData[0])}</div>
                    </Card.Body>
                  </Link>
                </Card>
                <Card className='mb-3 box-shadow rounded-4' >
                  <Card.Body >
                    <Link to={`/invoice/${routerParams.id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                      <div className='d-flex justify-content-between align-items'>
                        <div>
                          <div className='primary-color'><b>Invoice</b></div>
                          {(transactionData[0]?.invoice_details && transactionData[0]?.invoice_details[0]?.status) && <div className='fs-14'>Status: {transactionData[0]?.invoice_details && "Invoice Generated"}</div>}
                          {transactionData[0]?.invoice_details?.length && <div className='fs-14'>Number of Invoices: {transactionData[0]?.invoice_details?.length}</div>}
                          {transactionData[0]?.invoice_details?.filter((el: any) => el.status === 'cancelled').length > 0 && <div className='fs-14'>Cancelled Invoices: {transactionData[0]?.invoice_details?.filter((el: any) => el.status === 'cancelled').length}</div>}
                        </div>
                        <div>
                          {transactionData[0]?.invoice_details?.length > 0 && <div className='text-success'><FaCheckCircle /></div>}
                        </div>
                      </div>
                    </Link>
                  </Card.Body>
                </Card>
                {!isBuyer && <Card className='mb-3 box-shadow rounded-4' >
                  <Card.Body >
                    <Link to={`/packing-details/${routerParams.id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                      <div className='d-flex justify-content-between align-items'>
                        <div>
                          <div className='primary-color'><b>Packing & Inspections</b></div>
                          {transactionDeliveryData?.status &&
                            transactionData[0]?.invoice_details?.some(
                              (el: any) => (el?.package_details?.status === "skipped")
                            ) ? (
                            <div className='fs-14'>Status : Skipped</div>
                          ) : (
                            <div className='fs-14'>Status : {transactionPackingData?.status}</div>
                          )}
                        </div>
                        {(transactionData[0]?.invoice_details?.length > 0 && transactionPackingData?.status === 'Packing completed') && <div className='text-success'><FaCheckCircle /></div>}
                        {(transactionData[0]?.invoice_details?.length > 0 && transactionPackingData?.status !== 'Packing completed') && <div className="dot-wrapper"><GoDotFill className='slow orange-color' /></div>}
                      </div>
                    </Link>
                  </Card.Body>
                </Card>}
                {!isBuyer && <Card className='mb-3 box-shadow rounded-4' >
                  <Card.Body >
                    <Link to={`/delivery-details/${routerParams.id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                      <div className='primary-color'><b>Delivery Tracking</b></div>
                      <div className='d-flex justify-content-between align-items'>
                        <div className='fs-14'>
                          {transactionDeliveryData?.status && 
                          transactionData[0]?.invoice_details?.some(
                              (el: any) => (el?.order_track?.status === "skipped")
                            ) ? (
                              <div>Status : Skipped</div>
                            ) : (
                              <div>Status : {transactionDeliveryData?.status}</div>
                            )}
                        </div>
                        {transactionPackingData?.status === 'Packing completed' && (
                          <>
                            {transactionData[0]?.invoice_details?.some(
                              (el: any) => (el.delivery_status === 'delivery completed' && el?.order_track?.delivery_status === "Completed" || el?.order_track?.status === "skipped")
                            ) ? (
                              <div className="text-success">
                                <FaCheckCircle />
                              </div>
                            ) : (
                              <div className="dot-wrapper">
                                <GoDotFill className="slow orange-color" />
                              </div>
                            )}
                          </>
                        )}

                      </div>
                    </Link>
                  </Card.Body>
                </Card>}
                {!isBuyer && <Card className='mb-3 box-shadow rounded-4' >
                  <Card.Body >
                    <Link to={`/stock-details/${routerParams.id}`} style={{ textDecoration: 'none', color: '#000000' }}>
                      <div className='d-flex justify-content-between align-items'>
                        <div>
                          <div className='primary-color'><b>Stock Reconciliation</b></div>
                          {transactionStockReconciliationData?.status && <div className='fs-14'>Status: {transactionStockReconciliationData?.status}</div>}
                        </div>
                        {transactionData[0]?.invoice_details?.some(
                          (el: any) => (el.delivery_status === 'delivery completed' && el?.order_track?.delivery_status === 'Completed' || el?.order_track?.status === 'skipped')) && (
                            <>
                              {transactionStockReconciliationData?.status === 'Stock resolved' ? (
                                <div className="text-success">
                                  <FaCheckCircle />
                                </div>
                              ) : (
                                <div className="dot-wrapper">
                                  <GoDotFill className="slow orange-color" />
                                </div>
                              )}
                            </>
                          )}
                      </div>
                    </Link>
                  </Card.Body>
                </Card>}
                {!isBuyer && <Card className='mb-3 box-shadow rounded-4' >
                  <Card.Body onClick={openDownloadPopup} style={{ cursor: 'pointer' }}>
                    <div className='d-flex justify-content-between align-items'>
                      <div>
                        <div className='primary-color'><b>Payment Reconciliation</b></div>
                        {transactionPaymentReconciliationData?.status && <div className='fs-14'>Status: {transactionPaymentReconciliationData?.status}</div>}
                      </div>
                      {(transactionStockReconciliationData?.status === 'Stock resolved' && transactionPaymentReconciliationData?.status === 'Payment resolved') && <div className='text-success'><FaCheckCircle /></div>}
                      {(transactionStockReconciliationData?.status === 'Stock resolved' && transactionPaymentReconciliationData?.status !== 'Payment resolved') && <div className="dot-wrapper"><GoDotFill className='slow orange-color' /></div>}
                    </div>
                  </Card.Body>
                </Card>}
              </div>
            </div>}
          </div>
        }
      </>
      }
    </div>
  )
}
